import { BalanceSolicitation } from "./balanceSolicitation.model";
import { Corban } from "./corban.model";
import { OperationLog } from "./operationLog.model";
import { Processor } from "./processor.model";
import { Product } from "./product.model";
import { User } from "./user.model";
import { Bank } from "./bank.model";
export type Proposal = {
  inancialInfo?: FinancialInfo | null;
  id?: string;
  shortHash?: string | null;
  externalId?: string | null;
  status?: string;
  customStatus?: string | null;
  anticipatedYears?: number | null;
  annualCET?: number | null;
  monthlyCET?: number | null;
  operationDate?: string | null;
  disbursementDate?: string | null;
  cancellationDate?: string | null;


  sellerId?: string;
  Seller?: User;

  processorId?: string;
  Processor?: Processor | null;

  corbanId?: number;
  Corban?: Corban;

  balanceSolicitationId?: string;
  BalanceSolicitation?: BalanceSolicitation | null;

  naturalPersonId?: string | null;
  NaturalPerson?: NaturalPerson | null;

  chosenFinancialInfoId?: string | null;
  chosenFinancialInfo?: FinancialInfo | null;
  optionsFinancialInfo?: FinancialInfo[];

  BankDetail?: BankDetail | null;
  Contract?: Contract | null;
  UnicoData?: UnicoData | null;
  OperationLog?: OperationLog[];

  createdAt?: string;
};

export type NaturalPerson = {
  id?: string;
  name?: string | null;
  motherName?: string | null;
  birthDate?: string | null;
  document?: string;
  documentType?: string;
  address?: Address | null;
  addressId?: string | null;
  phoneNumber?: string | null;
  email?: string | null;
  nationality?: string | null;
  occupation?: string | null;
  civilStatus?: string;

  createdAt?: string;
  updatedAt?: string | null;

  Proposal?: Proposal[] | null;
};

export type Address = {
  addressName?: string;
  zipCode?: string;
  city?: string;
  uf?: string;
  number?: string;
  district?: string | null;
  complement?: string | null;
};

export type FinancialInfo = {
  id?: string;
  commission?: number | null;
  balance?: number | null;
  desiredAmount?: number | null;
  issueAmount?: number | null;
  releasedAmount?: number | null;
  insuranceAmount?: number | null;
  withoutTacAmount?: number | null;
  tacInput?: number | null;
  agioInput?: number | null;
  tacOutput?: number | null;
  agioOutput?: number | null;
  monthlyRate?: number | null;
  annualRate?: number | null;
  iof?: number | null;
  disbursementDate?: string | null;
  externalProductId?: string | null;
  externalId?: string | null;
  productId: string;
  Product?: Product | null;

  Installments?: Installment[] | null;

  proposalId?: string | null;
  Proposal?: Proposal | null;
  ChosenProposal?: Proposal | null;
  createdAt?: string;
};

export type BankDetail = {
  id?: string;
  pixKeyType?: string;
  pixKey?: string | null;
  account?: string | null;
  agency?: string | null;
  bankCode?: string | null;
  accountDigit?: string | null;
  accountType?: string | null;
  proposalId?: string;
  Bank?: Bank | null;
  Proposal?: Proposal | null;
  createdAt?: string;
};

export type Contract = {
  id?: string;
  ccbId: string;
  contractUrl: string;
  signedContractUrl: string;
  paymentReceipt?: string | null;

  proposalId: string;
  Proposal?: Proposal | null;
  createdAt?: string;
};

export type UnicoData = {
  id?: string;
  unicoId: string;
  unicoScore: number;
  unicoStatus: string;
  unicoFingerprint: string;
  frontDocument: string;
  backDocument: string;
  frontTyping: string;
  faceMatch: string;
  lastFormalizationDate: string;
  evidenceSet?: string | null;

  proposalId: string;
  Proposal?: Proposal | null;
  createdAt?: string;
};

export type Installment = {
  id?: string;

  dueDate: string;
  principalAmount: number;
  amortization: number;
  releasedAmount: number;
  issueAmount: number;
  interest: number;
  financeTax: number;
  payment: number;
  iof: number;
  addedFixedCosts?: number;

  financialInfoId?: string | null;
  FinancialInfo?: FinancialInfo | null;

  createdAt?: string;
};

enum ProposalStatus {
  PENDING_CONFIRMATION = 'PENDING_CONFIRMATION',
  PENDING_FORMALIZATION = 'PENDING_FORMALIZATION',
  PENDING_REFORMALIZATION = 'PENDING_REFORMALIZATION',
  PENDING_BANK_ANALYSIS = 'PENDING_BANK_ANALYSIS',
  PENDING_PAYMENT = 'PENDING_PAYMENT',
  PENDING_USER_REVIEW = 'PENDING_USER_REVIEW',
  PAYED = 'PAYED',
  SELFSERVICE = 'SELFSERVICE',
  IN_CANCELLATION = 'IN_CANCELLATION',
  CANCELED = 'CANCELED',
  CANCELED_BY_CLIENT = 'CANCELED_BY_CLIENT',
  REPROVED = 'REPROVED',
  ERROR_CREATE_BIOMETRIC_VALIDATION = 'ERROR_CREATE_BIOMETRIC_VALIDATION'
}

export type ReducedProposal = {
  id: string,
  shortHash: string | null,
  origin: "SELFSERVICE" | "NORMAL" | "SYSTEM",
  status: ProposalStatus,
  customStatus: string | null,
  createdAt: string | null,
  disbursementDate: string | null,
  financialReleasedAmount: number | null,
  financialProductName: string | null,
  sellerName: string | null,
  sellerLastName: string | null,
  naturalPersonId: string | null,
  naturalPersonName: string | null,
  naturalPersonDocument: string | null,
  naturalPersonUpdatedAt: string | null,
  selfServiceName: string | null,
  corbanId: number | null,
  corbanBusinessName: string | null,
  creditPromoterBusinessName: string | null,
  unicoLastFormalizationDate: string | null
}

export enum ProposalCustomStatusItenStatus {
  AGUARDANDO = 'aguardando',
  ERRO = 'erro',
  SUCESSO = 'sucesso',
  PENDING = 'aguardando' // Alias for AGUARDANDO for backward compatibility
}
export type ProposalCustomStatus = {
  confirmacao: {
    criacao_proposta_bancarizadora: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    },
    criacao_processo_seg_identidade: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    },
    analise_proposta_banco: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    }
  },
  acoes: {
    correcao_dados_pessoais_bancarios: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    },
    correcao_dados_bancarios: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    },
    correcao_dados_proposta_banco: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    },
    tentar_novamente_proposta_banco: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    },
    criar_processo_seg_identidade: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    },
    refazer_processo_seg_identidade: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    },
    analise_identidade: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    },
    analisar_proposta_banco: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    }
  },
  formalizacao: {
    ccb_entregue: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    },
    bloqueio_saldo: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    },
    seguranca_identidade: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    },
    assinatura_contrato: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    },
    envio_contrato_assinado: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    }
  },
  pagamento: {
    processando_pagamento: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    },
    pago: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    }
  },
  cancelamentos: {
    bloqueio_saldo_negado: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    },
    cancelado_usuario: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    },
    reprovado_seg_identidade: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    },
    cancelamento_outros: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    }
  }
}
export const AccountTypeLabels = {
  CHECKING_ACCOUNT: "Conta Corrente",
  SAVINGS_ACCOUNT: "Poupança",
};
